import React, { useState } from 'react'
import { applicationsForAdapters } from './catalog'
import { applicationsTabLabel, fileTypeCount, NO_APPLICATIONS } from './layoutBuilderCopy'
import './layoutBuilder.css'

const SIDES = [
  { key: 'source', label: 'Source', adapters: flow => flow.sourceAdapters },
  { key: 'destination', label: 'Destination', adapters: flow => flow.destinationAdapters }
]

// "Available applications / file types" for one catalog flow: a Source / Destination tab row over a
// scrollable list of the applications behind that side's adapters. A row expands to its file
// types, one at a time; switching tabs collapses it.
export default function FlowApplications ({ flow, applications }) {
  const [side, setSide] = useState('source')
  const [expandedId, setExpandedId] = useState(null)
  const bySide = Object.fromEntries(SIDES.map(item => [item.key, applicationsForAdapters(item.adapters(flow), applications)]))
  const current = bySide[side]

  return (
    <div className='layoutBuilder-chip-applications'>
      <div role='tablist' className='layoutBuilder-chip-tabs'>
        {SIDES.map(item => (
          <button
            type='button'
            role='tab'
            key={item.key}
            id={`${flow.id}-${item.key}-tab`}
            aria-selected={side === item.key}
            aria-controls={`${flow.id}-applications-panel`}
            className={`layoutBuilder-chip-tab${side === item.key ? ' is-active' : ''}`}
            onClick={() => {
              setSide(item.key)
              setExpandedId(null)
            }}
          >{applicationsTabLabel(item.label, bySide[item.key].length)}
          </button>
        ))}
      </div>
      <div role='tabpanel' id={`${flow.id}-applications-panel`} aria-labelledby={`${flow.id}-${side}-tab`} className='layoutBuilder-chip-applications-list'>
        {current.length === 0 && <p className='layoutBuilder-chip-applications-empty'>{NO_APPLICATIONS}</p>}
        {current.map(application => {
          const expanded = expandedId === application.id
          return (
            <div key={application.id}>
              <button
                type='button'
                className='layoutBuilder-chip-application-row'
                aria-expanded={expanded}
                aria-controls={`${flow.id}-${application.id}-filetypes`}
                onClick={() => setExpandedId(expanded ? null : application.id)}
              >
                <span>{application.name}</span>
                <span className='layoutBuilder-chip-application-count'>{fileTypeCount(application.fileTypes.length)}</span>
              </button>
              <ul className='layoutBuilder-chip-filetypes' id={`${flow.id}-${application.id}-filetypes`} hidden={!expanded}>
                {application.fileTypes.map(fileType => <li key={fileType.id}>{fileType.name}</li>)}
              </ul>
            </div>
          )
        })}
      </div>
    </div>
  )
}
